import { SET_FILTER_COUNT, SET_CURRENT_FILTER } from "../action-types/archiveFilter"

const initArchiveFilter = {
    currentFilter: "all",
    count: {
        all: undefined,
        archive: undefined,
        unarchive: undefined,
    },
}
export default function archiveFilterReducer(state = initArchiveFilter, action) {
    switch (action.type) {
        case SET_FILTER_COUNT: {
            return {
                ...state,
                count: action.payload,
            }
        }
        case SET_CURRENT_FILTER: {
            return {
                ...state,
                currentFilter: action.payload,
            }
        }
        default:
            return state
    }
}
